import React, { useEffect, useState } from "react";
import styled from "styled-components";


import dummy from "./dummy.json";
import { ReportItem } from "./optionUtils/DataTable/lib/DataTable.type";
import MarkdownParsing from "./optionUtils/MarkdownParsing";
import { Common } from "@src/styles/Common";

interface OwnProps {
    summaryData?: ReportItem[];
    charDelay?: number;
    wordDelay?: number;
    isAnimationEnabled?: boolean;
    isSuccess: boolean;
}

const MissgoAIGuide = ({ summaryData, charDelay = 3, wordDelay = 8, isSuccess }: OwnProps) => {
    const searchParams = new URLSearchParams(location.search);
    const isAnimationEnabled = searchParams.get("isAnimationEnabled") === "false" ? false : true;
    const [displayedData, setDisplayedData] = useState<ReportItem[]>([]);

    useEffect(() => {
        const dataToDisplay = isSuccess ? summaryData : dummy.summary.data;
        if (!dataToDisplay) return;

        if (!isAnimationEnabled || !isSuccess) {
            setDisplayedData(dataToDisplay);
            return;
        }

        setDisplayedData([]);
        let isMounted = true;

        const typeSequentially = async () => {
            const textOptions = new Set(['#', '##', '###', '####', 'p', 'blockquote']);

            for (let i = 0; i < dataToDisplay.length; i++) {
                if (!isMounted) break;

                const currentItem = dataToDisplay[i];
                if (!textOptions.has(currentItem.option)) {
                    setDisplayedData((prev) => [...prev, currentItem]);
                    continue;
                }

                const initialItemState = { ...currentItem, value: '' };
                setDisplayedData((prev) => [...prev, initialItemState]);

                let currentText = '';
                const words = currentItem.value.split(' ');

                for (const word of words) {
                    if (!isMounted) break;

                    for (const char of word) {
                        if (!isMounted) break;
                        await new Promise((r) => setTimeout(r, charDelay));
                        currentText += char;
                        setDisplayedData((prev) => {
                            const newData = [...prev];
                            newData[i] = { ...newData[i], value: currentText };
                            return newData;
                        });
                    }

                    await new Promise((r) => setTimeout(r, wordDelay));
                    currentText += ' ';
                    setDisplayedData((prev) => {
                        const newData = [...prev];
                        newData[i] = { ...newData[i], value: currentText };
                        return newData;
                    });
                }
            }
        };

        typeSequentially();

        return () => {
            isMounted = false;
        };
    }, [summaryData, isAnimationEnabled, charDelay, wordDelay, isSuccess]);

    return (
        <ReportContainer>
            <WarningMessageBox>
                <div>※</div>
                <span>
                    본 정보는 <br />
                    미스고 데이터를 토대로 생성형 AI 서비스를 <br />
                    제공하고 있으므로 미스고의 동의 없이 무단수집은 <br />
                    민·형사상 처벌을 받을 수 있습니다.
                </span>
            </WarningMessageBox>
            <Line />
            <MarkdownParsing data={displayedData} />
        </ReportContainer>
    );
};

const ReportContainer = styled.div`
    max-width: 768px;
    height: 100%;
    margin: 0 auto;
    padding: 14px;
    color: #333;
`;

const WarningMessageBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 6px;
    margin-bottom: 24px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    color: ${Common.colors.darkGrey04};
`;

const Line = styled.div`
    border: 1px solid #ddd;
    margin-bottom: 24px;
`;

export default MissgoAIGuide;
